<template>
    <div class="detail" v-if="page_show">
        <div class="swiper-box">
            <swiper>
                <swiper-slide v-for="(item,index) in product.img_path" :key="index"><img :src="item"></swiper-slide>
            </swiper>
        </div>

        <!-- 商品信息 -->
        <div class="info-box">
            <div>
                <span class="fs_24 c_main">¥</span>
                <span class="fs_36 c_main">{{product.price}}&nbsp;</span>
                <span class="fs_26 c_b3 line_through">¥{{product.price_original}}</span>
            </div>
            <p class="c_1a fs_32 lh_40 mt_20">{{product.name}}</p>
            <div class="mt_20">
                <span class="fs_24 c_98 lh_40">已售{{product.sales}}</span>
                <div class="share-box" @click="share_show=!share_show">
                    <span class="jcicon jcicon-fenxiang1 fs_26 c_98"></span>
                    <span class="fs_24 c_98">分享</span>
                </div>
            </div>
        </div>

        <!-- 服务保障 -->
        <div class="flex__between__center publicity" v-if="attach_vic.length" @click="ensure_modal=true">
            <span class="fs_24 c_98 publicity__item ellipsis_one" v-for="(item,index) in attach_vic" :key="index">•&ensp;{{item.name}}</span>
            <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
        </div>

        <!-- 评价 -->
        <div class="modular">
            <div class="modular__title">
                <span class="fs_36 c_1a fw_500">商品评价</span>
                <span class="fs_30 c_80">（{{review_total}}）</span>
            </div>
            <div class="evaluate__item" v-if="review.length">
                <div class="flex item__header">
                    <img :src="review[0].headimgurl" alt="">
                    <div class="flex__null__around ml_20">
                        <span class="fs_30 c_name">{{review[0].nickname}}</span>
                        <div> 
                            <span class="fs_26 c_98">{{review[0].create_time}}</span>
                            <span class="fs_26 c_98" v-if="review[0].product_sku_name">&emsp;规格:{{review[0].product_sku_name}}</span>
                        </div>
                    </div>
                </div>
                <p class="fs_30 c_1a mt_20 lh_40" v-if="review[0].content">{{review[0].content}}</p>
                <div class="flex wrap item__img mt_20" v-if="review[0].img_path.length">
                    <img :src="item" alt="" v-for="(item,index) in review[0].img_path" :key="index" @click="previewImage(index)">
                </div>
            </div>
            <div class="flex__between__center modular__footer" @click="link('/Mall/EvaluateList/'+product.id)">
                <span class="fs_28 c_1a">查看全部评论</span>
                <span class="jcicon jcicon-jiantouarrow487 fs_30 c_98"></span>
            </div>
        </div>

        <!-- 详情 -->
        <div class="modular" v-if="product.description">
            <div class="modular__title">
                <span class="fs_36 c_1a fw_500">商品详情</span>
            </div>
            <div v-html="product.description" class="modular__content">{{product.description}}</div>
        </div>

        <!-- 保障modal -->
        <div v-show="ensure_modal" class="ensure-box">
            <div class="layer" @click="ensure_modal=false"></div>
            <div class="ensure">
                <div class="ensure__content">
                    <p class="flex__around fs_36 c_1a">服务保障</p>
                    <div class="flex ensure-item" v-for="(item,index) in attach" :key="index">
                        <img :src="item.icon" alt="">
                        <div class="flex__null__between ensure-item__right">
                            <span class="fs_28 c_4d">{{item.name}}</span>
                            <span class="fs_22 c_b3 mt_15">{{item.brief}}</span>
                        </div>
                    </div>
                </div>
                <button class="close-btn" @click="ensure_modal=false">关闭</button>
            </div>
        </div>
        <div class="flex__between footer">
            <div class="flex__between__center footer__left">
                <div class="flex__center__between" @click="collect">
                    <span class="jcicon jcicon-shoucang fs_50 lh_50" :class="is_collect?'c_main':'c_b3'"></span>
                    <span class="fs_20" :class="is_collect?'c_main':'c_4d'">收藏</span>
                </div>
                <div class="flex__center__between" v-link="'/Mall/Cart'">
                    <span class="jcicon jcicon-gouwuche1 fs_40 c_b3 lh_50"></span>
                    <span class="fs_20 c_4d">购物车</span>
                </div>
            </div>
            <div class="flex footer__right">
                <button @click='show=!show;orders.settlement_type=1'>加入购物车</button>
                <button @click='show=!show;orders.settlement_type=2'>立即购买</button>
            </div>
        </div>

        <!-- 规格modal -->
        <div>
            <div class='layer' v-show='show' @click='show=!show'></div>
            <div class='model' v-show='show'>
                <div class='model__info'>
                    <img :src='product.cover_img'>
                    <div class='flex__null__between model__info__right'>
                        <div class='flex__between__center'>
                            <div>
                                <span class='fs_24 c_main'>¥</span>
                                <span class='fs_32 c_main'>{{product.price}}</span>
                            </div>
                            <span class='jcicon jcicon-error c_b3' @click='show=!show'></span>
                        </div> 
                        <span class='fs_24 c_98'>库存：{{product.stock}}</span>
                        <span v-if="product_spec.length" class='fs_24 c_98'>已选规格：{{sku_name}}</span>
                    </div>
                </div>
                <div class="model__spec-box">
                    <div class='model__spec' v-for="(item,index) in product_spec" :key="index ">
                        <span class='fs_28 c_33'>{{item.spec_title}}</span>
                        <div class='flex wrap '>
                            <div 
                            v-for="(item1,index1) in item.spec_item" 
                            :key="index1" 
                            @click="switchSpec(index,index1)"
                            class="flex__center__center model__spec__item" :class="[item1.active?'active':'',item1.apply?'actives':'']">
                                <span>{{item1.spec_item_value}}</span>
                            </div>
                        </div>
                    </div>

                    <div class='flex__between__center model__num'>
                        <span class='fs_28 c_33'>数量</span>
                        <div class='stepper_components'>
                            <div class='count' @click='reduce'>
                                <span class='jcicon jcicon-jianhaocu c_4d fs_22'></span>
                            </div>
                            <div class='count count--big'>
                                <span class='fs_24'>{{orders.number}}</span>
                            </div>
                            <div class='count' @click='add'>
                                <span class='jcicon jcicon-jiahao c_4d fs_22'></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class='model__footer' @click="sure">
                    <button>确定</button>
                </div>
            </div>
        </div>
        <!-- 浮层菜单 -->
        <back-top v-back-top v-scroll-show:800="is_top" :show="is_top.value" :url="'/Mall/Index'"></back-top>
        <!-- 分享浮层 -->
        <share-layer :show_share="share_show" @isShow="isShow"></share-layer>
    </div>
</template>
<script>
export default {
    name: 'Detail',
    data(){
        return{
            page_show:false,// 页面展示优化
            share_show: false,//分享图层
            is_top:{value:false},
            product:{
                img_path:[]
            },
            product_spec: [],
            attach:[],
            attach_vic: [],
            review_total: 0,
            review:[],
            ensure_modal: false,
            is_collect: 0,
            orders:{
                user_id:localStorage.user_id,
                number: 1,
                settlement_type:1,
                product_id: '',
                sku: ''
            },
            show: false, //规格modal
            sku_name: '请选择',
            sku_arr: [], //选中规格id数组
        }
    },
    methods:{
        // 分享图层
        isShow(data){
            this.share_show=data;
        },
        link(url){
            this.$router.push(url);
        },
        // 收藏
        collect(){
            this.axios.post('/wechat.php/Mall/submitCollect',{
                user_id:localStorage.user_id,
                product_id:this.product.id,
                source: 1
            }).then(
                res=>{
                    this.$toast(res.data.message);
                    if(res.data.code==1&&res.data.message=='收藏成功'){
                        this.is_collect= 1;
                    }else if(res.data.code==1&&res.data.message=='取消收藏成功'){
                        this.is_collect= 0;
                    }
                }
            )
        },
        // 选择规格 (下级规格 往里面push)
        switchSpec(index,index1) {
            // 判断当前是否还有库存
            if (this.product_spec[index].spec_item[index1].apply) {
                this.$toast('库存不足');
                return;
            }

            let product_sku = this.product_sku;//匹配规格数据
            let product_spec = this.product_spec;//规格列表
            let sku_arr = this.sku_arr;//选中规格
            sku_arr[index] = product_spec[index].spec_item[index1];
            let chose_sku = sku_arr.concat();//选中规格id,副本
            // 选中或取消
            if (product_spec[index].spec_item[index1].active) {
                this.initial();
                // 取消 去掉样式
                product_spec[index].spec_item[index1].active = false;
                chose_sku.splice(index, 1,'');
                for(let i=0;i<chose_sku.length;i++){
                    if(chose_sku[i]){
                        this.proving(chose_sku[i].spec_item_id,res=>{
                            this.splitCheck(res,i);
                        }) 
                    }
                }
            } else {
                //清空当前行选中规格
                for (let i = 0; i < product_spec[index].spec_item.length; i++) {
                    product_spec[index].spec_item[i].active = false;
                }
                product_spec[index].spec_item[index1].active = true;
                this.proving(chose_sku[index].spec_item_id,res=>{
                    this.splitCheck(res,index);
                })  
            }

            let sku_code_str = ''; //副数组转为的字符串
            let chose_sku_vic=[];
            let chose_sku_name=[];
            let sku_name = '';//规格名称
            let product = this.product;
            let check_length=true;
            for(let i=0;i<chose_sku.length;i++){
                if(!chose_sku[i]){
                    check_length=false;
                    break;
                }
            }
            // 规格选全
            if (chose_sku.length == product_spec.length&&check_length) {
                for(let i=0;i<chose_sku.length;i++){
                    chose_sku_vic.push(chose_sku[i].spec_item_id);
                    chose_sku_name.push(chose_sku[i].spec_item_value);
                }
                sku_code_str=chose_sku_vic.sort().join('_');
                sku_name=chose_sku_name.join(',');
                for (let key in product_sku) {
                    if (key == sku_code_str) {
                        product.price = product_sku[key].price;
                        product.cover_img = product_sku[key].cover_img;
                        product.stock = product_sku[key].stock;
                        this.orders.sku = sku_code_str;
                    }
                }
            } else {
                product.price = this.product_vic.price;
                product.cover_img = this.product_vic.cover_img;
                sku_name = '请选择';
                product.stock = this.product_vic.stock;
                this.orders.sku = sku_code_str;
            }
            this.sku_arr=chose_sku;
            this.product_spec=product_spec;
            this.product=product;
            this.sku_name=sku_name;
        },
        // 初始
        initial(){
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            this.splitCheck(being_item);
        },
        // 返回有当前item_id的
        proving(spec_item_id, callback) {
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (key.indexOf(spec_item_id) != -1&&product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            callback(being_item);
        },
        //拆分赋值
        splitCheck(being_item,index){
            let product_spec = this.product_spec;
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        product_spec[i].spec_item[j].apply = true;
                    }
                }
            }
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        for(let m = 0; m < being_item.length; m++){
                            if(being_item[m]==product_spec[i].spec_item[j].spec_item_id){
                                product_spec[i].spec_item[j].apply = false;
                                break;
                            }
                        }
                    }
                }
            }
        },
        // 对象深度克隆 
        cloneObj(obj){
            let str, newobj = obj.constructor === Array ? [] : {};
            if(typeof obj !== 'object'){
                return;
            } else if (JSON) {
                str = JSON.stringify(obj), //序列化对象
                newobj = JSON.parse(str); //还原
            } else {//如果不支持以上方法
                for (let i in obj) {
                    newobj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i];
                }
            }
            return newobj;
        },
        // 减
        reduce() {
            if (this.sku_arr.length != this.product_spec.length){
                this.$toast('请选择规格');
                return;
            }
            if (this.orders.number > 1) {
                this.orders.number=this.orders.number - 1;
            } else {
                this.$toast('不能再减了');
            }
        },
        // 加
        add() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            if (!this.product.stock) {
                this.$toast('库存不足啦!');
            } else if (this.orders.number < this.product.stock) {
                this.orders.number=this.orders.number + 1;
            }else{
                this.orders.number=this.product.stock;
                this.$toast('库存不足啦!');
            }
        },
        // 下单
        sure() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            if (!this.product.stock) {
                this.$toast('库存不足啦!');
                return;
            }
            // 加入购物车
            if (this.orders.settlement_type == 1) {
                this.axios.post('/wechat.php/Mall/updateDetailCart',this.orders).then(
                    res => {
                        if (res.data.code == 1) {
                            this.show=false;
                            this.$dialog.alert({
                                message: res.data.message
                            })
                        }else{
                            this.$toast(res.data.message);
                        }
                    })
            } else { 
                // 立即购买
                this.axios.post('/wechat.php/Mall/getOrderReady', this.orders).then(
                    res => {
                        if (res.data.code == 1) {
                            this.$router.push({path:'/Mall/Order',query: {
                                product_id:this.orders.product_id,
                                number:this.orders.number,
                                sku:this.orders.sku,
                                settlement_type:2}})
                        }else{
                            this.$toast(res.data.message);
                        }
                })
            }
        },
        // 查看大图
        previewImage(index){
            this.$wx.previewImage({
                url: this.review[0].img_path[index],
                urls: this.review[0].img_path
            })
        }
    },
    mounted(){
        this.httpPost({
            url:'/Mall/getProductDetailData',
            params:{product_id: this.$route.params.id},
            loading:1
        }).then(
            res=>{
                if(res.code==1){
                    this.page_show=true;
                    this.orders.product_id=res.data.product.id;
                    this.product_sku=res.data.product_sku;
                    this.product=res.data.product;
                    this.product_vic=this.cloneObj(res.data.product);
                    this.product_spec=res.data.product_spec;
                    this.attach=res.data.attach;
                    if(this.attach.length>4){
                        this.attach_vic=this.attach.concat().splice(0,4);
                    }else{
                        this.attach_vic=this.attach;
                    }
                    this.review_total=res.data.review_total;
                    this.review=res.data.review;
                    this.is_collect=res.data.is_collect;
                    this.product.description=res.data.product.description.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
                    this.initial();
                    // 分享预配置
                    this.$wx.setConfig();
                    this.$wx.share({
                        title: this.product.name, // 分享标题
                        desc: this.product.name,
                        link:"https://ym.jucheng01.net/vue/Mall/Detail/" +this.product.id,
                        imgUrl: this.product.cover_img 
                    })
                }
            }
        )
    }
}
</script>

<style scoped>
.swiper-box img{
    width:750px;
    height:600px;
}
.info-box{
    position: relative;
    padding: 25px 30px 25px;
    background: #fff;
}
.publicity{
    height: 80px;
    padding: 0 30px;
    border-top: 2px solid #e6e6e6;
    background: #fff;
}
.publicity__item{
    width: 150px;
}
.share-box{
    position: absolute;
    bottom: 25px;
    right: 0;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    border-radius: 25px 0 0 25px;
    background: #f0f0f0;
}
/* 模块 */
.modular{
    margin-top: 15px;
    padding: 0 30px 0;
    background: #fff;
}
.modular__title{
    padding: 30px 0;
}
.modular__content{
    padding-bottom:30px;
}
.evaluate__item{
    padding-bottom: 30px;
}
.item__header img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.item__img img{
    width: 165px;
    height: 165px;
    margin: 10px 0 0 10px;
}
.item__img img:nth-child(4n+1){
    margin-left: 0;
}
.item__reply{
    padding: 10px 20px;
    background: #f5f5f5;
    border-radius: 10px;
}
.modular__footer{
    height: 90px;
    border-top: 2px solid #e6e6e6;
}
.null-box{
    border-top: 2px solid #e6e6e6;
    height: 90px;
}

/* modal */
.layer{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.ensure{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 3;
    background: #fff;
}
.ensure__content{
    padding: 30px;
}
.ensure-item{
    padding: 30px 0;
    border-top: 2px solid #e6e6e6;
}
.ensure-item:nth-child(2){
    border: 0;
}
.ensure-item img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.ensure-item__right{
    margin-left: 20px;
}
.close-btn{
    width: 100%;
    height: 98px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    z-index: 1;
}
.footer__left{
    width: 100%;
    padding: 0 30px;
    background: #fff;
    border-top: 2px solid #e6e6e6;
}
.footer__right button:first-child{
    width: 280px;
    height: 98px;
    background: #FFAE27;
    font-size: 32px;
    color: #fff;
}
.footer__right button:last-child{
    width: 260px;
    height: 98px;
    background: #F93A42;
    font-size: 32px;
    color: #fff;
}

/* 规格model */
.model{
  position: fixed;
  bottom: 0;
  z-index: 3;
  width: 100%;
  background: #fff;
}
.model__info{
  display: flex;
  padding: 30px 30px 0;
}
.model__info img{
  display: block;
  width: 220px;
  height: 220px;
  margin-top: -60px;
  border: 2px solid #E6E6E6;
  border-radius: 10px;
  background: #fff;
}
.model__info__right{
  width: 440px;
  margin-left: 30px;
}
.size-table{
  width: 120px;
  height: 30px;
  background: #1a1a1a;
  line-height: 30px;
}
.model__spec-box{
    max-height: 700px;
    padding: 0 30px;
    margin: 10px 0;
    overflow: auto;
}
.model__spec{
  padding: 30px 0;
  border-bottom: 2px solid #e6e6e6;
}
.model__spec__item{
    min-width: 60px;
    margin: 20px 20px 0 0;
    padding: 0 20px;
    height: 60px;
    line-height: 56px;
    text-align: center;
    font-size: 26px;
    color: #989898;
    border: 2px solid #CBCBCB;
    border-radius: 6px;
}
.active{
    color: #F93A42;
    border: 2px solid #F93A42;
}
.actives{
    background: #e8e8e8;
    color: #c8c9cc;
    border: 2px solid #e8e8e8;
    border: none;
}
.model__num{
    height: 120px;
}
/* 计步器 */
.stepper_components{
    display: flex;
    justify-content: space-between;
    width: 200px;
    border: 2px solid #e6e6e6;
}
.stepper_components .count{
    width: 66px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.stepper_components .count--big{
    width: 85px;
    height: 60px;  
    border-right: 2px solid #e6e6e6;
    border-left: 2px solid #e6e6e6;
    text-align: center;
}

.model__footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/Detail.vue